import {CompanyProps, translatedCompanyProps} from 'modules/companies/types';
import {BillingDetailsProps} from 'modules/orders/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface InvoiceProps extends BillingDetailsProps {
  id: string;
  companyId: string;
  company: CompanyProps;
  issued: boolean;
  month: string;
  startDate: Date;
  endDate: Date;

  // OCCURRENCES
  companyOccurrences: number;
  cityOccurrences: number;
}

export const translatedInvoiceProps: TranslatedKeys<InvoiceProps> = {
  companyId: 'Empresa',
  company: {...translatedCompanyProps, name: 'Empresa'},
  issued: 'Concluído',
  month: 'Mês',
  startDate: 'Data de início',
  endDate: 'Data de fim',

  // ORDER
  rawTotal: 'Total bruto',
  consideredTotal: 'Total considerado',

  // DELIVERIES
  paidDeliveryPrice: 'Valor pago da entrega',
  freeDeliveryPrice: 'Valor em entrega grátis',
  totalDeliveryPrice: 'Taxa de entrega',

  // COMPANY
  companyCouponDiscount: 'Cupons empresa',
  companyProductsDiscount: 'Desconto em produtos empresa',
  companyFreeDeliveryPrice: 'Entrega grátis empresa',
  retainedEarningsAmount: 'Dinheiro com a empresa',
  companyAmount: 'Repasse empresa',

  // CITY
  cityCouponDiscount: 'Cupons cidade',
  cityProductsDiscount: 'Desconto em produtos cidade',
  cityFreeDeliveryPrice: 'Entrega grátis cidade',
  cityRawAmount: 'Comissão cidade (Bruta)',
  cityAmount: 'Comissão cidade ',

  // BALANCE
  balanceAmount: 'Carteira',

  // FRANCHISE
  franchiseAmount: 'Valor franquia',

  // OCCURRENCES
  companyOccurrences: 'Ocorrências empresa',
  cityOccurrences: 'Ocorrências cidade',
};
